<template>
  <div>
    <el-row :gutter="10">
      <el-col :span="24">
        <div class="side-frame-warning">
          <div class="d-flex align-items-center">
            <span style="font-size: 14px; color: #606266">{{
              $l('group_title_cust') || '客户执行情况'
            }}</span>
            <dict-select
              class="ml-2"
              size="small"
              clearable
              v-model="form.depCode"
              url="/sys/common/dict/depPrimary"
              :placeholder="$l('tips_select_dep') || '请选择部门'"
              filterable
              @change="updateTeamCode"
            ></dict-select>
            <dict-select
              class="ml-2"
              clearable
              v-model="form.teamCode"
              url="/sys/common/dict/depByParentCode"
              :placeholder="$l('tips_select_team') || '请选择团队'"
              :body="teamparams"
              filterable
              :disabled="!form.depCode"
              size="small"
            ></dict-select>
            <dict-select
              class="ml-2"
              clearable
              v-model="form.custCode"
              url="/digitalCenter/common/dict/customer"
              :placeholder="$l('tips_select_cust') || '请选择客户'"
              filterable
              size="small"
            ></dict-select>
            <b-button class="ml-2" variant="primary" size="sm" @click="query">
              <i class="fa fa-search" />
            </b-button>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
// 初始表单
const initForm = {
  keyword: '',
  depCode: '',
  teamCode: '',
  custCode: '',
}
export default {
  props: {},
  data() {
    return {
      teamparams: { parentCode: '' },
      form: { ...initForm },
    }
  },
  watch: {
    'form.depCode'() {
      this.teamparams = { parentCode: this.form.depCode }
    },
  },
  mounted() {
    // this.query()
  },
  methods: {
    // 重置查询条件
    reset() {
      this.form = { ...initForm }
    },
    query() {
      this.$emit('query', this.form)
    },
    updateTeamCode() {
      this.form.teamCode = ''
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
